module.exports = __webpack_public_path__ + "static/media/2.2f6450b2.jpg";